import React, { useEffect, useState } from "react";
import './currencyconverter.css';
import axios from "axios";
import News from "../news/News";
import { Helmet } from "react-helmet";

const CurrencyConverter = () => {
  const [amount, setAmount] = useState(1);
  const [currency, setCurrency] = useState([]);
  const [fromCurrency, setFromCurrency] = useState("USD");
  const [toCurrency, setToCurrency] = useState("INR");
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [isFromDropdownOpen, setIsFromDropdownOpen] = useState(false);
  const [isToDropdownOpen, setIsToDropdownOpen] = useState(false);
  const [searchTermFrom, setSearchTermFrom] = useState("");
  const [searchTermTo, setSearchTermTo] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://v6.exchangerate-api.com/v6/6e02838dc14605edc7bec09a/codes"
        );
        setCurrency(response.data.supported_codes);
      } catch (error) {
        console.error("Error fetching currency codes:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const convertCurrency = async () => {
      try {
        const response = await axios.get(
          `https://v6.exchangerate-api.com/v6/6e02838dc14605edc7bec09a/pair/${fromCurrency}/${toCurrency}/${amount}`
        );
        setConvertedAmount(response.data.conversion_result);
      } catch (error) {
        console.error("Error converting currency:", error);
      }
    };

    if (amount && fromCurrency && toCurrency) {
      convertCurrency();
    }
  }, [amount, fromCurrency, toCurrency]);

  const getCurrencyLabel = (code) => {
    const found = currency.find(([c]) => c === code);
    return found ? `${found[0]} - ${found[1]}` : code;
  };

  // Filtered currency lists
  const filteredFromCurrency = currency.filter(
    ([code, name]) =>
      (code.toLowerCase().includes(searchTermFrom.toLowerCase()) ||
        name.toLowerCase().includes(searchTermFrom.toLowerCase())) &&
      code !== toCurrency
  );

  const filteredToCurrency = currency.filter(
    ([code, name]) =>
      (code.toLowerCase().includes(searchTermTo.toLowerCase()) ||
        name.toLowerCase().includes(searchTermTo.toLowerCase())) &&
      code !== fromCurrency
  );

  const swappingCurrency = () => {
    let temp = fromCurrency;
    setFromCurrency(toCurrency);
    setToCurrency(temp);
  }

  return (
    <>
       <Helmet>
        <title>Currency Converter - USD, INR & All Major Currencies</title>
        <meta name="description" content="Convert currencies instantly with live exchange rates. Get accurate USD, INR, and global currency conversions along with the latest forex news." />
        <meta name="keywords" content="currency converter, USD to INR, forex, exchange rates, currency conversion, currency news, INR, USD, currency calculator" />
        <meta name="author" content="Your Company Name" />
      </Helmet>

      <section className="currency-converter-section">
        <div className="container">
          <div className="row">
            <div className="main-heading">
              <h3>Currency Converter</h3>
            </div>

            <div className="currency-form">
              {/* Amount Input */}
              <div className="input-box">
                <label>Amount</label>
                <div className="amount">
                  <span className="currency-code">{fromCurrency}</span>
                  <input
                    type="number"
                    onChange={(e) => {
                      const value = e.target.value;
                      setAmount(value);
                    }}
                    value={amount}
                    min="1"
                  />
                </div>
              </div>

              <div className="currency-selector">
                {/* From Currency Dropdown */}
                <div className="select-box">
                  <label>From</label>
                  <div className="currency-selectbox">
                    <div
                      className="custom-dropdown"
                      onClick={() => setIsFromDropdownOpen((prev) => !prev)}
                    >
                      <div
                        className="selected-option"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsFromDropdownOpen((prev) => !prev);
                        }}
                      >
                        {getCurrencyLabel(fromCurrency)}
                      </div>

                      {isFromDropdownOpen && (
                        <div className="currency-options">
                          <input
                            type="text"
                            placeholder="Search..."
                            value={searchTermFrom}
                            onChange={(e) => setSearchTermFrom(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            className="search-input"
                          />
                          <ul>
                            {filteredFromCurrency.length > 0 ? filteredFromCurrency.map(([code, name]) => (
                              <li
                                key={code}
                                className={code === fromCurrency ? "selected" : ""}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setFromCurrency(code);
                                  setIsFromDropdownOpen(false);
                                  setSearchTermFrom("");
                                }}
                              >
                                {code} - {name}
                              </li>
                            )) : (
                              <>
                                <li className="no-result">No matching currency</li>
                              </>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="swapping-btn" onClick={swappingCurrency}>
                  <img src="./img/swap.png" alt="swap button" />
                </div>

                {/* To Currency Dropdown */}
                <div className="select-box">
                  <label>To</label>
                  <div className="currency-selectbox">
                    <div
                      className="custom-dropdown"
                      onClick={() => setIsToDropdownOpen((prev) => !prev)}
                    >
                      <div
                        className="selected-option"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsToDropdownOpen((prev) => !prev);
                        }}
                      >
                        {getCurrencyLabel(toCurrency)}
                      </div>

                      {isToDropdownOpen && (
                        <div className="currency-options">
                          <input
                            type="text"
                            placeholder="Search..."
                            value={searchTermTo}
                            onChange={(e) => setSearchTermTo(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            className="search-input"
                          />
                          <ul>
                            {filteredToCurrency.length > 0 ? (
                              filteredToCurrency.map(([code, name]) => (
                                <li
                                  key={code}
                                  className={code === toCurrency ? "selected" : ""}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setToCurrency(code);
                                    setIsToDropdownOpen(false);
                                    setSearchTermTo("");
                                  }}
                                >
                                  {code} - {name}
                                </li>
                              ))
                            ) : (
                              <li className="no-result">No matching currency</li>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Result */}
              {convertedAmount !== null && (
                <div className="result input-box">
                  <h4>
                    {amount} {fromCurrency} = <span>{convertedAmount.toFixed(2)}</span> {toCurrency}
                  </h4>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row">
            <News heading="Currency News" api="https://gnews.io/api/v4/search?q=INR%20vs%20USD&lang=en&country=in&max=5&apikey=197836aefe5d224564223fa9660e5c0e" />
          </div>
        </div>
      </section>
    </>
  );
};

export default CurrencyConverter;
